import PropTypes from 'prop-types';
import React from 'react';
import GreyhoundRacingRacecardResultRunner from "./GreyhoundRacingRacecardResultRunner";

export default function GreyhoundRacingRacecardResultNonRunners(props) {

  if (props.nonRunners && props.nonRunners.length) {
    return (
      <section>
        <div className="gh-racing-racecard-section-header">
          <h4>Non Runners</h4>
        </div>
        {
          props.nonRunners.map(nonRunner => {
            return <GreyhoundRacingRacecardResultRunner
              runner={nonRunner}
              key={nonRunner.key}
            />
          })
        }
      </section>
    )
  } else {
    return <section />
  }
}

GreyhoundRacingRacecardResultNonRunners.propTypes = {
  nonRunners: PropTypes.arrayOf(PropTypes.object)
};



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/components/GreyhoundRacingRacecardResultNonRunners.js